import { Fragment } from "react";
import ResourceLayouts from "layouts/ResourceLayouts";
import Hero from "container/terms/Hero";
import Content from "container/terms/Content";
import BuyProxies from "container/home/BuyProxies";

const TermsOfServices = () => {
    return (
        <Fragment>
            <ResourceLayouts title="Terms of Service">
                <Hero />
                <Content />
                <BuyProxies />
            </ResourceLayouts>
        </Fragment>
    );
};

export default TermsOfServices;